// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"974a54e3","453":"4cb9f65d","455":"de88932f","644":"bdae4568"}[chunkId] + ".chunk.js";
};